import { render, staticRenderFns } from "./ResourceLinks.vue?vue&type=template&id=287aae24&scoped=true&"
import script from "./ResourceLinks.vue?vue&type=script&lang=js&"
export * from "./ResourceLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287aae24",
  null
  
)

export default component.exports